<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu pageTitle="edit_expense" />
    <CreateExpensesFrom
      :referenceno="referenceno"
      :date="date"
      :categories="categories"
      :warehouses="warehouses"
      :form="form"
      :is-loading="isLoading"
      :is-edit-mode="isEditMode"
      @update:referenceno="referenceno = $event"
      @update:date="date = $event"
      @update:field="(field, value) => form[field] = value"
      @generate-reference="fetchNextRef"
      @submit="submitExpense"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import CreateExpensesFrom from "../../components/Expenses/CreateExpenses/CreateExpensesFrom.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useExpenseForm } from "../../composables/useExpenseForm";

export default defineComponent({
  name: "EditExpensesPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    CreateExpensesFrom,
    MainFooter,
  },
  setup() {
    return useExpenseForm();
  },
});
</script>
